<template>
	<router-view :key="$route.fullPath" v-if="$siteSettings?.data && $route.name == 'Maintenance'"  />
	<template v-else-if="$siteSettings?.data ">
		<div v-if="showMarquee && $route.name == 'Home' && validAnnouncements?.length" class="exch-marquee-notify-section">
			<marquee :speed="40">
                <template v-for="(item, index) in validAnnouncements" :key="item?.id ?? index">
                    <span :style="{ color: item?.color_code }">{{ item?.msg }}</span>
                    <span v-if="index < validAnnouncements?.length - 1" class="marquee-separator">&nbsp;&nbsp;|&nbsp;&nbsp;</span>
                </template>
            </marquee>
			<span @click="hideMarquee" class="exch-marquee-close-btn">
				<img src="@/assets/images/marquee_cross.svg">
			</span>
		</div>
		<div class="demodev" v-if="$route.name != 'NotFound' && $route.name != 'Maintenance' && ($auth.user?.isDemo || ($auth?.user?.actw == 'WB' && !$auth.user?.isDemo))">
			<button class="demo_login">
				<span v-if="$auth.user?.isDemo">{{ $t('demo-account', 'Demo Account') }}</span>
				<span v-if="$auth?.user?.actw == 'WB' && !$auth.user?.isDemo">{{ $t('playing-with-welcome-bonus', 'Playing with WelcomeBonus') }}</span>
			</button>
		</div>
		<div data-bs-toggle="modal" data-bs-target="#notification-alert" ref="notifyMe">
		</div>
		<NotificationAlert @allowNotifications="allowNotifications" @cancelNotifications="cancelNotifications"/>	
		<!-- header section -->
		 <template v-if="!underMaintenance">
	
			 <header class="header-wapper" :class=" showMarquee && ($siteSettings?.data?.announcement) && ($siteSettings?.data?.announcement?.[0]?.msg || $siteSettings?.data?.announcement?.[1]?.msg) && $route.name == 'Home' ? 'is-marque' : ''"  v-if="checkForHeaderShow()">
				 <Header></Header>
				 <SportSelectionHeader  v-if="checkRoute()" ></SportSelectionHeader>
			 </header>
		 </template>
	
		<router-view :key="$route.fullPath" v-if="$siteSettings?.data"  />
	
		<!-- footer start -->
		<footer v-if="(footerHideRoute() && cricketFightRoute()) && !underMaintenance">
			<Footer :footerMenuopen="footerMenuopen"  v-if="!underMaintenance"></Footer>
		</footer>
		<Offers />	
		<DomainSwitchModal :DomainSwitchPoster="DomainSwitchPoster" v-if="DomainSwitchPoster?.image" />
		<SpinWheel ref="SpinWheelRef" />
	</template>
	<!-- <UserIdModal /> -->
	<!-- Modal Footer Menu -->
    <FooterMenu @popup-state-change="handlePopupState" />
	<div  class="toster-wrapper" v-if="successMsg || errorMsg">
		<SuccessModal v-if="successMsg" :message="successMsg" />
		<ErrorModal v-if="errorMsg" :message="errorMsg" />
	</div>
	<div class="home-page-loader" v-if="globalLoader || !$siteSettings?.data">
        <!-- <img alt="logo" class="loader-img" id="logoImage" :src="$siteSettings?.data?.aws_url + $siteSettings?.data?.storage_path?.domain_image + $siteSettings?.data?.logo"> -->
        <span class="dot-wave"><span></span> <span></span> <span></span></span>                              
    </div>
	<AndroidBanner/>
</template>

<script>
import { getWalletBalance } from "./shared/services/walletPolling";
import { AUTH_TOKEN } from "./shared/constants/cookies-const";
import { setHeaders } from '@/shared/services/headers';
import { mapGetters } from 'vuex';
import socketService from "./socket/sport-socket-service";
import { defineAsyncComponent } from 'vue';
import notificationAlert from '@/shared/services/notificationAlert';
import { isApp as checkIsApp } from '@/shared/services/checkPlatform';
import marquee from '@/shared/services/marqueeService';
// import userIdAndOfferService from "./shared/services/userIdAndOfferService";
export default {
	name: "App",
	mixins: [notificationAlert],
	data() {
		return {
			onLine: navigator.onLine,
			showBackOnline: false,
			scY: 0,
			scTimer: 0,
			showMarquee: true,
			footerMenuopen:  false,
			interval:null,
			isApp : false,
			siteVersionTimer: null,
			walletBalanceTimer: null,
			isWalletBalancePollingStarted: false,
			isSiteStatusCalled: false,
		}
	},
	computed: {
		...mapGetters(['successMsg', 'errorMsg', 'siteVersion','underMaintenance','eventDetailHideSections','globalLoader', 'logInData','sportsEventMarketType','bonusData','userSpinData']),
		routePath() {
			return this.$route.name;
		},
		isSpinBonus() {
            return this?.bonusData?.find(bd => bd?.bonusType == "spin & wheel");
        },
		DomainSwitchPoster() {
            return this.$siteSettings?.data?.poster && this.$siteSettings?.data?.poster?.length && this.$siteSettings?.data?.poster?.find(s => s?.poster_type == 14);
        },
		validAnnouncements() {
            const list = this.$siteSettings?.data?.announcement || [];
            return list.filter(item => item?.msg && item?.msg?.trim()?.length > 0);
        }
	},
	mounted() {
		this.isApp = checkIsApp()
		window.store = this.$store;
		window.cookies = this.$cookies;
		window.router = this.$router;
		window.authorization_token = `Bearer ${this.$cookies.get(AUTH_TOKEN)}`
		// this.$store.dispatch('setGlobalLoader', false);
		setHeaders();
		 if (this.$auth.status) {
			if(!this.$auth.user?.notificationUnsubscribed && !this.$auth.user?.notificationSubscribed){
				this.requestNotificationPermission()
			}
		}	

		//checking internet connection
		window.addEventListener('online', this.updateOnlineStatus);
		window.addEventListener('offline', this.updateOnlineStatus);
		window.addEventListener('scroll', this.onScroll);
		this.$errorToast(null);
		this.$successToast(null);
	},
	async created() {
		this.socketAllEvents();
		await this.getSiteVersion();
	},
	beforeUnmount() {
		clearTimeout(this.siteVersionTimer);
		clearTimeout(this.walletBalanceTimer);
	},
	beforeDestroy() {
		window.removeEventListener('online', this.updateOnlineStatus);
		window.removeEventListener('offline', this.updateOnlineStatus);
	},
	components: {
		marquee,
        Header: defineAsyncComponent(() =>
            import('@/shared/components/header/Header.vue')
        ),
		Footer: defineAsyncComponent(() =>
            import('@/shared/components/footer/Footer.vue')
        ),
		ErrorModal: defineAsyncComponent(() =>
            import('./shared/components/modal/ErrorModal.vue')
        ),
		SuccessModal: defineAsyncComponent(() =>
            import('./shared/components/modal/SuccessModal.vue')
        ),
		NotificationAlert: defineAsyncComponent(() =>
            import('./shared/components/modal/NotificationAlert.vue')
        ),
		Offers: defineAsyncComponent(() =>
            import('./shared/components/header/Offers.vue')
        ),
		// UserIdModal: defineAsyncComponent(() =>
        //     import('./shared/components/modal/UserIdModal.vue')
        // ),
		SportSelectionHeader: defineAsyncComponent(() =>
            import('@/shared/components/sport-selection/SportSelectionHeader.vue')
        ),
		FooterMenu: defineAsyncComponent(() => 
            import('@/shared/components/footer/FooterMenu.vue')
        ),
		AndroidBanner :defineAsyncComponent(() =>
			import('@/shared/components/header/AndroidBanneru.vue')
		),
		SpinWheel: defineAsyncComponent(() =>
			import('@/modules/SpinWheel/components/SpinWheel.vue')
		),
		DomainSwitchModal: defineAsyncComponent(() =>
			import('@/shared/components/modal/DomainSwitchModal.vue')
		),
    },
	methods: {
		handlePopupState(isOpen) {
			this.footerMenuopen = isOpen
		},
		setTheme(theme) {
			localStorage.setItem('default_class', theme)
			document.documentElement.className = theme;
		},
		getSiteVersion(isRecursiveCall = false) {
			if(!this.isApp) this.interval = setInterval(this.checkModalStatus, 60 * 1000);
			if(!isRecursiveCall && this.sportsEventMarketType !== 'up-down-market') {
			this.$store.dispatch('setGlobalLoader', true);
			}
			this.$apiCall('get', 'GET_SITE_VERSION', null, 'user', { domain: window.location.hostname }).then(async response => {
				// this.$store.dispatch('setGlobalLoader', false);
				if (response && response.status == 200) {
					if (response?.data?.status === 0) {
						this.$errorToast(response.data.debug[0]);
					} else {
						let resData = response?.data?.data;
						let currentVersion = resData.version;
						let userSystemVersion = this.siteVersion || 0;		
						if (!userSystemVersion || currentVersion != userSystemVersion || !this.$siteSettings.data) {
							this.isSiteStatusCalled = false;
							this.$store.dispatch('setSiteVersion', currentVersion);
							this.getSiteSettingsServiceCall();
						} else {
							this.setSiteSttings(this.$siteSettings.data);
						}
						if (resData.maintenance) {
						const { from_date, to_date } = resData.maintenance;
							const fromDateTime = new Date(from_date).getTime();
							const toDateTime = new Date(to_date).getTime();
							const currentDateTime = Date.now();

							const isInMaintenanceWindow = fromDateTime <= currentDateTime && currentDateTime <= toDateTime;

							if (fromDateTime && toDateTime && isInMaintenanceWindow) {
							this.$store.dispatch('setUnderMaintenance', resData.maintenance);
								this.$router.push({ name: 'Maintenance' });
							}
							if(this.sportsEventMarketType !=='up-down-market') this.$store.dispatch('setGlobalLoader', false)
						}
						else {
							if (this.underMaintenance) {
								this.$router.push( {name: 'Home'});
							}
						this.$store.dispatch('setUnderMaintenance', null); 
						if(this.sportsEventMarketType !=='up-down-market') this.$store.dispatch('setGlobalLoader', false);
						}
					    // Recursive call every 30 seconds
						this.scheduleSiteVersionPoll();
					}
				}
			}).catch(error => {
				if(this.sportsEventMarketType !=='up-down-market') this.$store.dispatch('setGlobalLoader', false);
				if (error) {
					this.$errorToast(error[0]);
				}
				this.scheduleSiteVersionPoll();
			});
		},

		scheduleSiteVersionPoll() {
			clearTimeout(this.siteVersionTimer);
			this.siteVersionTimer = setTimeout(() => {
				this.getSiteVersion(true);
			}, 30000);
		},
		getSiteSettingsServiceCall() {
			this.$store.dispatch('setGlobalLoader', true);
			this.$apiCall('get', 'GET_SITE_SETTINGS', null, 'user', { domain: window.location.hostname }).then(async response => {
				this.$store.dispatch('setGlobalLoader', false);
				if (response && response.status == 200) {
					if (response?.data?.status === 0) {
						this.$errorToast(response.data.debug[0]);
					} else {
						let resData = response.data.data
						resData.siteSetting.announcement = JSON.parse(resData.siteSetting.announcement)
						resData.siteSetting.offer = resData.siteSetting.poster.find( pos => pos.poster_type == 12);
						resData.siteSetting.provider_currency = resData.siteSetting.provider_currency.reduce((a,b) =>{
							a[b.provider_id] = b.currency
							return a;
						}, {})
						this.$store.dispatch('setSectionUrl', resData.section_url);
						this.$store.dispatch('setSettings', resData);
						this.$store.dispatch('setBonusData', resData.bonus_data);
						this.setSiteSttings(resData.siteSetting);
						this.$store.dispatch('setLanguagesData', this.allLanguages);
						if (!this.isSpinBonus) {
							const modal = document.getElementById('spin-wheel')
							if (modal) {
								this.$helper.closeModal('spin-wheel')
								if (this.$refs?.SpinWheelRef?.resetSpinWheel) {
									this.$refs.SpinWheelRef.resetSpinWheel();
								}
								setTimeout(() => {
									this.$router.push({ name : 'Home'})
								}, 400);
							}
						}
					}
				}
			}).catch(error => {
				this.$store.dispatch('setGlobalLoader', false);
				if (error) {
					this.$errorToast(error[0]);
				}
			});
		},

		setSiteSttings(siteData) {
			try {
				if (this.isSiteStatusCalled) return;
				if (siteData.languagesList) {
					this.$setCurrentLangData(siteData.languagesList, siteData.language_code, siteData.aws_url).then(() => {
					this.$store.dispatch('setLanguagesData', siteData.languagesList);
				}).catch(e => {
				})
			}
				setTimeout(() => {
					if(!this.isApp) this.androidPosterOpenPopUp();
				}, 500);

			this.$store.dispatch('setSettings', siteData);
			this.setManifest(siteData);
			if(siteData.meta_tags) {
				document.head.innerHTML += siteData.meta_tags;
			};
			if(siteData.meta_pixel_code) {
				this.addFacebookPixel(siteData.meta_pixel_code);
			}
			if(siteData.g_tags) {
				this.setGoogleAnalyticsTag(siteData.g_tags);
			};
			if(siteData.site_map) {
				const sitemapLink = document.createElement("link");
				sitemapLink.rel = "sitemap";
				sitemapLink.type = "application/xml";
				sitemapLink.title = "Sitemap";
				sitemapLink.href = siteData.aws_url + siteData.storage_path.site_map + siteData.site_map;
				document.head.appendChild(sitemapLink);
			};
			// Create FAVICON
			const favElement = document.createElement('link');
			favElement.rel = 'icon';
			favElement.href = siteData.aws_url + siteData.storage_path.domain_image + siteData.fav_logo;
			document.head.insertAdjacentElement('beforeend', favElement);
			
			const title = document.getElementById("title");
			title.text = siteData.site_title;
			let is_offer = localStorage.getItem("is_offer");
			try {
			if (siteData.front_css != null && siteData.front_css != '') {
				const styleElement = document.createElement('style');
				styleElement.type = 'text/css';
				styleElement.appendChild(document.createTextNode(siteData.front_css));
				document.head.insertAdjacentElement('beforeend', styleElement);
				this.convertCSSToJson(siteData.front_css);
				localStorage.setItem('default_class', 'CustomPropertiesTheme');
			} else if (localStorage.getItem('default_class')) {
				document.documentElement.className = localStorage.getItem('default_class');
				localStorage.setItem('CustomPropertiesTheme', null);
			} else {
				this.setTheme('purple');
				localStorage.setItem('CustomPropertiesTheme', null);
			}
			} catch (error) {
				console.log("CSS injection error: ", error);  // ✅ won't break the app
			}
			if (this.$auth.status){

				if (!this.isWalletBalancePollingStarted) {
					this.isWalletBalancePollingStarted = true;
					getWalletBalance();
				}
				setTimeout(() => {
					if(this.$route.name != 'changePassword')  {
						this.handleOffer();
						if(!this.userSpinData && !this.$auth.user?.isDemo && this.isSpinBonus && this.$siteSettings?.data?.business_type == 2){
							this.getSpinBonusData()
						}
					}
				}, 300);
			}

			 this.isSiteStatusCalled = true;

		} catch (error) {
				this.$errorToast(error);
			}
		},
		handleOffer(){
			let isOffer = this.$store.getters.isOffer;
			if (this.$auth.status && this.$siteSettings.data.offer != null && isOffer && this.$siteSettings?.data?.business_type == 2) {
				this.$helper.openModal("#offer_pop_up");
			}
		},
		getSpinBonusData(){
			this.$apiCall('get', 'GET_USER_WHEEL_INFO', null, 'user').then(async response => {
				if (response && response.status == 200) {
					if (response?.data?.status === 0) {
						this.$errorToast(response.data.debug[0]);
					} else {
						let spinBonusUserData = response?.data?.data;
                        this.$store.dispatch('setUserSpinData',spinBonusUserData);
                        if(spinBonusUserData?.available_spins && spinBonusUserData?.today_remaining_spin_limit){
							// this.$router.push({ name: 'Home' }); 
							setTimeout(()=>{
								this.$helper.openModal('#spin-wheel')
							},300)
                        }else{
                            this.$router.push({ name: 'Home' }); 
                        }
					}
				}
			}).catch(error => {
				if (error) {
					this.$errorToast(error[0]);
				}
			});
		},
		setManifest(resData) {
			let manifestName = resData.domain_name.charAt(0).toUpperCase() + resData.domain_name.slice(1).toLowerCase();
			var dynamicManifest = {
				name: manifestName,
				short_name: manifestName,
				start_url: window.location.origin,
				display: 'standalone',
				icons: [{
					src: resData.app_logo ? resData.aws_url + resData.storage_path?.domain_image + resData.app_logo : resData.aws_url + resData.storage_path?.domain_image + resData.fav_logo,
					sizes: "256x256 512x512 192x192 144x144",
					type: "image/png",
					purpose: 'any'
				}]
			}
			
			// Manifest Blob
			const stringManifest = JSON.stringify(dynamicManifest);
			const blob = new Blob([stringManifest], { type: 'application/json' });
			const manifestURL = URL.createObjectURL(blob);
			
			// Manifest Creation
			const favElement = document.createElement('link');
			favElement.rel = 'manifest';
			favElement.href = manifestURL;
			document.head.insertAdjacentElement('beforeend', favElement);
			
			// IOS APK Logo
			let logo = resData.aws_url + resData.storage_path?.domain_image + resData.logo;
			document.querySelector('#appleIcon').setAttribute('href', logo);
			document.querySelector('#appleLaunchIcon').setAttribute('href', logo);

			// IOS App title
			const metaTag = document.createElement('meta');
			metaTag.setAttribute('name', 'apple-mobile-web-app-title');
			metaTag.setAttribute('content', manifestName);
			document.head.insertAdjacentElement('beforeend', metaTag);

		},
		checkForHeaderShow() {
			if (this.eventDetailHideSections && this.eventDetailHideSections.includes('show_full_screen') && this.routePath == 'sports-event-detail') {
				return false;
			} else {
				return true;
			}
		},
		updateOnlineStatus(e) {
			const {
				type
			} = e;
			this.onLine = type === 'online';
		},
		androidPosterOpenPopUp(){
			const modalEl = document?.getElementById('andriodposter');
			const isOpen = modalEl?.classList?.contains('show');
			const lastClosed = localStorage.getItem("modalClosedAt");
			const now = Date.now();
			if( (!lastClosed || ((now - lastClosed) >= (6 * 60 * 60 * 1000))) && !isOpen  && !this.isApp 
				&& this.$siteSettings?.data?.poster?.filter(s => s?.poster_type == 13)?.length && !this.underMaintenance){
				setTimeout(()=>{
					this.$helper.openModal("#andriodposter");
				}, 500)
			}
		},
		convertCSSToJson(cssString) {
			const styles = {};
			const customProperties = {};

			// Extract custom properties from :root
			const rootMatch = cssString.match(/:root\s*{([^}]*)}/);
			if (rootMatch) {
				const rootDeclarations = rootMatch[1].split(';').filter(declaration => declaration.trim() !== '' && (declaration.includes('--primary-color') || declaration.includes('--secondary-color') ));
				rootDeclarations.forEach(declaration => {
					const [property, value] = declaration.split(':').map(part => part.trim());
					customProperties[property] = value;
				});
			}
			localStorage.setItem('CustomPropertiesTheme',JSON.stringify(customProperties));
		},
		onScroll() {
			if (this.scTimer) return;
			this.scTimer = setTimeout(() => {
				this.scY = window.scrollY;
				clearTimeout(this.scTimer);
				this.scTimer = 0;
			}, 100);
		},
		socketAllEvents() {
			if (this.$store.getters.stateUser) {
				socketService.emit("sub", 'depositRequest-' + this.$store.getters.stateUser.userid);
				socketService.emit("sub", 'logout-' + this.$store.getters.stateUser.userid);
				socketService.emit("sub", 'banned-' + this.$store.getters.stateUser.userid);

				socketService.on("DepositRequest", (data) => {
					if (data.type == "myId") {
						if (data.notify_type == 1) {
							this.$store.dispatch('setNotification');
							this.$successToast('New Notification...')
						}
					}
				});
				socketService.on("logout", (data) => {
					if (data.type == "logout") {
						// logout user from users
						// if (data.notify_type == 1) {
						// 	this.$store.dispatch('setNotification');
						// 	this.showSuccessModalFunc('New Notification...')
						// }
					}
				});
				socketService.on("banned", (data) => {
					if (data.type == "match_ban") {
						// match ban condition
					} else if (data.type == 'league_ban') {
						// league ban condition
					}
				});

			}
		},
		checkRoute() {
			let routeName = this.$route.name
			let allowedRoutes = [
				'sports',
				'sports-book',
				'virtual-sports',
				'sports-league',
				'games',
				'shared-games',
				'Home'
			]
			return allowedRoutes.includes(routeName)
		},
		footerHideRoute() {
			let routeName = this.$route.name
			let restrictedRoutes = [
				'account',
				'refer-earn',
				'rules',
				'term-and-condition',
				'settings',
				'changePassword',
				'profile',
				'edit-profile',
				'profit-loss',
				'profit-loss-detail',
				'statements',
				'statement-detail',
				'matka-details',
				'bonus',
				'bets',
				'wallet-deposit',
				'deposit-payment-method',
				'make-deposit',
				'wallet-withdraw',
				'withdraw-select-account',
				'withdraw-selected-account-detail',
				'proof',
				'sports-book',
				'deposit-withdraw-report',
				'wallet-gateway',
				'NotFound',
				'AffDashboard',
				'AffUsersList',
				'AffProfitLoss',
				'AffStatement',
				'AffReports',
				'UserProfitLoss',
				'UserProfitLossDetails',
				'completed-events'
			]
			return !restrictedRoutes.includes(routeName)
		},
		cricketFightRoute() {
			let routeName = this.$route.name
			let restrictedRoutes = [
				'MatchDetails'
			]
			return !restrictedRoutes.includes(routeName)
		},
		hideMarquee() {
            this.showMarquee = !this.showMarquee;
        },
		addFacebookPixel(pixelId) {
			const script = document.createElement('script');
			script.innerHTML = `
				!function(f,b,e,v,n,t,s)
				{if(f.fbq)return;n=f.fbq=function(){n.callMethod?
				n.callMethod.apply(n,arguments):n.queue.push(arguments)};
				if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
				n.queue=[];t=b.createElement(e);t.async=!0;
				t.src=v;s=b.getElementsByTagName(e)[0];
				s.parentNode.insertBefore(t,s)}(window, document,'script',
				'https://connect.facebook.net/en_US/fbevents.js');
				fbq('init', '${pixelId}');
				fbq('track', 'PageView');
			`;
			document.head.appendChild(script);

			// Add the noscript image
			const noscript = document.createElement('noscript');
			noscript.innerHTML = `
				<img height="1" width="1" style="display:none"
					src="https://www.facebook.com/tr?id=${pixelId}&ev=PageView&noscript=1"/>
			`;
			document.head.appendChild(noscript);
    	},
		setGoogleAnalyticsTag(gTag) {
			let script1 = document.createElement('script');
			script1.async = true;
			script1.src = `https://www.googletagmanager.com/gtag/js?id=${gTag}`;

			let script2 = document.createElement('script');
			script2.innerHTML = `
				window.dataLayer = window.dataLayer || [];
				function gtag(){dataLayer.push(arguments);}
				gtag('js', new Date());
				gtag('config', '${gTag}');
			`;

			document.head.appendChild(script1);
			document.head.appendChild(script2);
		},
	},
	beforeUnmount() {
		clearInterval(this.interval);
	},
	watch: {
		onLine(v) {
			if (v) {
				this.showBackOnline = true;
				setTimeout(() => {
					this.showBackOnline = false;
				}, 1000);
			}
		}
	}
};



</script>

<style scoped>
.marquee-separator {
    color: #ffffff;
}
</style>